import React, { Component } from 'react';
import './Services.css';
import en from '../../language/en/Services.json';
import es from '../../language/es/Services.json';
import { Link } from 'react-router-dom';
import { Typography, Icon, Snackbar, Slide } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import config from '../../config/config.json';

class Services extends Component {
	constructor() {
		super();
		this.state = {
			config: {
				lang: {
					en: en,
					es: es
				}
			},
			services: [],
			isLoading: true,
			openSnackbar: false
		};

		window.scrollTo(0, 1);
	}

	componentDidMount() {
		this.setState({ isLoading: true });
		let url = `${config.apiBaseUrl}/servicio`;

		//Obteniendo todos los servicios del centro
		fetch(url)
			.then(
				res => {
					return res.json();
				}
			)
			.then(
				data => {
					// console.log('services = ', data);
					this.setState({
						services: data
					});
				}
			)
			.catch(
				err => {
					console.log("error ", err);
				}
			);

		this.setState({ isLoading: false });
	}

	render() {
		const lang = this.state.config.lang;
		const selectedLanguage = (this.props.lang === 'en') ? lang.en : lang.es;

		/* const services = this.state.services.map((service, i) => {

			return (
				<tr key={ i }>
					<td>{ service.id }</td>
					<td>{ service.servicio }</td>
					<td>{ service.descripcion || 'No existe'}</td>
					<td>{ service.publico }</td>
					<td>
						<Link className="btn btn-sm blue" to={ '/service/' + (service.publico==='Si'? '': 'solicitar/') + service.id }>
							<i className="fa fa-search-plus"></i>
							Ver
						</Link>
					</td>
				</tr>
			)
		}); */

		const Service = (service) => {
			return (
				<div className="col-md-4">
					<div className="service-box-v1">
						<div>
							<Icon className="fa fa-dropbox color-grey" color="secondary" />
						</div>
						<Link to={'/service' + (service.publico === 'Si' ? '' : '/solicitar/') + service.ruta_acceso}>
							<Typography variant="h6" /* color="textPrimary" */ id={service.id} onClick={(e) => { if (service.ruta_acceso === '/') e.preventDefault(); this.setState({ openSnackbar: !this.state.openSnackbar }); }}>
								{service.servicio}
							</Typography>
						</Link>
						<Typography variant="subtitle2" align="justify" color="textSecondary">{service.descripcion}</Typography>

						<div className="bottom-progress"></div>
					</div>
				</div>
			)
		};

		const service = this.state.services;
		let Services = [];
		for (let i = 0; i < service.length; i += 3) {
			const row = i / 3;
			if (i + 1 < service.length) {
				if (i + 2 < service.length) {
					Services[row] =
						<div className="row margin-bottom-20" key={row}>
							{Service(service[i])}
							{Service(service[i + 1])}
							{Service(service[i + 2])}
						</div>

				}
				else {
					Services[row] =
						<div className="row margin-bottom-20" key={row}>
							{Service(service[i])}
							{Service(service[i + 1])}
						</div>

				}
			}
			else {
				Services[row] =
					<div className="row margin-bottom-20" key={row}>
						{Service(service[i])}
					</div>

			}
		}



		const TransitionLeft = (props) => {
			return <Slide {...props} direction="left" />;
		}

		const Alert = (props) => {
			return <MuiAlert elevation={6} variant="filled" {...props} />;
		}

		const handleClose = (event, reason) => {
			if (reason === 'clickaway') {
				return;
			}

			this.setState({ openSnackbar: false });
		};

		return (
			<div className="Services" id="services">
				{/* <div className="layer"></div> */}
				<div className="container">

					<div className="heading">
						<Typography variant="h4" className="efecto-espejo">
							Servicios Científicos Técnicos
                        </Typography>
					</div>

					{this.state.isLoading ? <h1>Loading...</h1> : Services}

					<Snackbar
						anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
						open={this.state.openSnackbar}
						onClose={handleClose}
						// message="Vea el elemento debajo"
						key={'top' + 'center'}
						TransitionComponent={TransitionLeft}
					>
						<MuiAlert severity="info" onClose={handleClose} >El elemento debajo, contiene el Pronóstico.</MuiAlert>
					</Snackbar>

				</div>
			</div>
		)
	}
}

export default Services;